import { useFetch } from 'hooks/useFetch/useFetch'
import type { FIELD_VALIDATION_ERROR } from 'refunds/constants/constants'
import type { BankDataInfo } from 'refunds/types/refundData'
import { StatusCode } from 'types/statusCodes'
import { env } from 'utils/envManager'
import { url } from 'utils/url'

interface ValidateBankDataOnServerProps {
	countryISO: string
}
interface ValidationResult {
	isValid: boolean
	fieldWithError?: keyof BankDataInfo
	errorType?: FIELD_VALIDATION_ERROR
}
interface ValidationError {
	status: number
	info?: {
		fieldWithError: keyof BankDataInfo
		errorType: FIELD_VALIDATION_ERROR
	}
}

export const useValidateBankDataOnServer = ({
	countryISO,
}: ValidateBankDataOnServerProps) => {
	const { fetcher } = useFetch()

	const validateBankDataOnServer = async (
		values: BankDataInfo
	): Promise<ValidationResult> => {
		try {
			await fetcher({
				url: url(`${env.NEXT_PUBLIC_SITE_BASE_URL}/ws-refunds/validate`, {
					countryISO,
				}),
				body: {
					bankData: { bankDataInfo: values, selected: true },
				},
				method: 'POST',
			})
			return { isValid: true }
		} catch (error) {
			const { status, info } = error as ValidationError
			return {
				isValid: false,
				...(status === StatusCode.BAD_REQUEST && {
					fieldWithError: info?.fieldWithError,
					errorType: info?.errorType,
				}),
			}
		}
	}

	return { validateBankDataOnServer }
}
